import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { RetailerDto } from '@emi/shared/models';
import * as Constants from '@emi/shared/constants';
import { HttpService } from '../http.service';

@Injectable({
  providedIn: 'root',
})
export class RetailersService {
  constructor(private httpService: HttpService) {}

  public getRetailers(filterData: object): Observable<RetailerDto> {
    return this.httpService.postHttp<RetailerDto>(
      Constants.ServiceConstants.RETAILERS,
      filterData
    );
  }
}
